module.exports = __webpack_public_path__ + "img/delete.3e065d0d.svg";